import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.11 Case 11</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="challenge_case_11"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 11. This is a positive case.
                Beginning at the level of the temporal and occipital regions,
                distinct white matter tracts are not readily identifiable on the
                right-hand side. In addition, there is increased activity in the
                cortical gray matter, extending to the cortical rim, seen here.
                Therefore, there is loss of gray-white contrast in the right
                temporal and occipital regions.
              </p>
              <p>
                On the left-hand side, distinct white matter tracts can be seen
                within the left temporal region, identified here. Less intense
                activity is seen in the surrounding gray matter. The gray-white
                contrast is preserved. In the left occipital region, identified
                here, once again there is loss of gray-white contrast and white
                matter tracts are not readily identifiable. It is important to
                review the slices immediately superior and inferior to this
                region to ensure that the loss of gray-white contrast can be
                seen at multiple levels, and in fact this is the case.
              </p>
              <p>
                Continuing to move superiorly, the loss of gray-white contrast,
                seen in the right temporal and occipital regions, continues. On
                the left-hand side, however, distinct white matter tracts are
                more readily identifiable, extending into the left occipital
                region. However, the left occipital region remains positive, as
                there was loss of gray-white contrast in the inferior aspect.
              </p>
              <p>
                As we enter into the frontal cortices, identified here, distinct
                white matter tracts can be seen on the left as well as on the
                right. Less intense activity is seen in the surrounding gray
                matter. The frontal cortices are negative, as there is no loss
                of gray-white contrast. In the posterior parietal region,
                increased activity is seen in the gray matter on the right as
                well as on the left-hand side. This loss of gray-white contrast
                can be seen throughout the posterior parietal region. Again
                moving superiorly, distinct white matter tracts are readily
                identifiable, coursing from the front of the brain to the back
                of the brain on the left as well as on the right. No increased
                activity is seen in the gray matter at this level. After
                reviewing all of the slices, it is clear that there is loss of
                gray-white contrast in the posterior parietal regions
                bilaterally, as well as in the right temporal and bilateral
                occipital regions. Therefore, this case is positive. If you
                called this case negative, you may want to review the case once
                again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-10"
          nextLesson="/module-4/module-4-1-12"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1053611138&entry_id=1_ms2mjdx6&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_ms2mjdx6"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
